import { apiClient } from "../../../api/client";
import * as ActionType from "./currency.type";
import { setToast } from "../../../util/toast";

export const getCurrency = () => async (dispatch) => {
  const res = await apiClient.get("currency/getCurrency");
  if (res.ok) {
    dispatch({ type: ActionType.GET_CURRENCY, payload: res.data?.currency });
  } else {
    console.error(res.message);
  }
};

export const getDefaultCurrency = () => async (dispatch) => {
  const res = await apiClient.get("currency/getDefaultCurrency");
  if (res.ok) {
    dispatch({
      type: ActionType.GET_DEFAULT_CURRENCY,
      payload: res.data?.defaultCurrency || res.data?.currency,
    });
  } else {
    console.error(res.message);
  }
};

export const createCurrency = (data) => async (dispatch) => {
  const res = await apiClient.post("currency/createCurrency", data);
  if (res.ok && res.data?.status) {
    dispatch({ type: ActionType.CREATE_CURRENCY, payload: res.data?.currency });
    setToast("success", "Currency created successfully");
  } else {
    setToast("error", res.data?.message || res.message);
  }
};

export const updateCurrency = (data) => async (dispatch) => {
  const res = await apiClient.patch("currency/updateCurrency", data);
  if (res.ok && res.data?.status) {
    dispatch({ type: ActionType.UPDATE_CURRENCY, payload: res.data?.currency });
    setToast("success", "Currency updated successfully");
  } else {
    setToast("error", res.data?.message || res.message);
  }
};

export const deleteCurrency = (id) => async (dispatch) => {
  const res = await apiClient.delete(`currency/deleteCurrency?currencyId=${id}`);
  if (res.ok && res.data?.status) {
    dispatch({ type: ActionType.DELETE_CURRENCY, payload: id });
    setToast("success", "Currency deleted successfully");
  } else {
    setToast("error", res.data?.message || res.message);
  }
};

export const enabledDisabled = (currency) => async (dispatch) => {
  const res = await apiClient.patch(
    `currency/defaultCurrency?currencyId=${currency?._id}`
  );
  if (res.ok && res.data?.status) {
    dispatch({
      type: ActionType.DEFAULT_CURRENCY,
      payload: {
        data: res.data?.currency || res.data?.currencies,
        id: currency?._id,
      },
    });
    setToast("success", "Default currency updated successfully");
  } else {
    setToast("error", res.data?.message || res.message);
  }
};
